import React from 'react';
import { StyleSheet } from 'react-native';
import Column from '../layout/Column';
function validateChildren(children) {
    return (React.Children.map(children, child => {
        if (child == null || child === false) {
            return true;
        }
        return React.isValidElement(child) ? !!child.props.id : false;
    }) || []).every(Boolean);
}
const Tabs = ({ activeTab, children, behaviour = 'unmount', childContainerProps }) => {
    const isValid = validateChildren(children);
    if (!isValid) {
        throw new Error('Every child of Tabs component should have a `id` prop');
    }
    if (behaviour === 'hide') {
        let firstTabFound = false;
        return (React.createElement(React.Fragment, null, React.Children.map(children, child => {
            if (React.isValidElement(child)) {
                const isActive = (!activeTab && !firstTabFound) || child.props.id === activeTab;
                if (!activeTab && !firstTabFound) {
                    firstTabFound = true;
                }
                const style = StyleSheet.flatten([childContainerProps?.style, !isActive && styles.hidden]);
                return (React.createElement(Column, { ...childContainerProps, style: style }, child));
            }
            return child;
        })));
    }
    // Default 'unmount' behaviour
    let matchingTab = null;
    React.Children.forEach(children, child => {
        if (React.isValidElement(child)) {
            if ((!activeTab && !matchingTab) || child.props.id === activeTab) {
                matchingTab = child;
            }
        }
    });
    return matchingTab || null;
};
const styles = StyleSheet.create({
    hidden: {
        display: 'none',
    },
});
export default React.memo(Tabs);
